import { get, post } from "./http";

/**
 * 初始化答题信息
 * @param {*} site 
 * @param {*} obt 
 */
export const init = (site, obt) => get("api/get_answer", {
    site: site,
    obt: obt,
});
/**
 * 获取试卷信息
 */
export const get_paper = () => post("api/get_paper");
/**
 * 提交试卷
 * @param {*} data 
 */
export const submit_paper = (data) => post("api/submit_paper", data);
/**
 * 获取红包
 */
export const send_redpack = () => post("api/send_redpack");
/**
 * 用户注册
 * @param {*} data 
 */
export const reg_user = (data) => post("api/reg_user", data);
/**
 * 校验登录状态
 * @param {*} data 
 */
export const check_uid = (data) => get("api/check_uid", data);




